import type { ReactNode } from 'react';

type Props = {
  icon: ReactNode;
  children: ReactNode;
};

export const NarrativeCommunityHeaderInfoBlock = ({
  icon,
  children,
}: Props) => {
  return (
    <div
      role="listitem"
      className="grid grid-cols-[65px_auto] items-center gap-x1 md:grid-cols-[85px_auto]"
    >
      <div className="relative">
        <div className="absolute inset-3 bg-p-grey-10 blur-2xl lg:inset-1" />
        <div className="relative z-10">{icon}</div>
      </div>
      <p className="mb-0 text-pretty text-xs font-strong text-solid">
        {children}
      </p>
    </div>
  );
};
